module.exports = __webpack_public_path__ + "img/multimodal_mental_health_dx_3.2644f9c1.png";